import { useState } from 'react';
import { Button } from '@simplywallst/ui-core';
import AnnouncementOutline from '@simplywallst/ui-core/icons/AnnouncementOutline';

import useNarrativePermission from '@/pages/Narrative/hooks/useNarrativePermission';
import { useCreateNarrativeAnnouncement } from '@/pages/Narrative/hooks';
import { AnnouncementModal } from '@/pages/Narrative/components/AnnouncementModal';

type Props = {
  id: string;
  slug: string;
};

export const CreateAnnouncement = ({ id, slug }: Props) => {
  const [isAnnouncementModalOpen, setIsAnnouncementModalOpen] = useState(false);
  const { narrativePermissions } = useNarrativePermission();
  const { mutate: createAnnouncement } = useCreateNarrativeAnnouncement({
    onSuccess: () => setIsAnnouncementModalOpen(false),
    slug,
  });

  if (!narrativePermissions?.canUpdateAnnouncement) {
    return null;
  }

  return (
    <>
      <Button
        data-cy-id="add-announcement-button"
        styleType="loud"
        onClick={() => setIsAnnouncementModalOpen(true)}
        alignIcon="left"
        className="!pl-7 sm:!pl-9"
      >
        <AnnouncementOutline />
        <span className="hidden sm:inline">Update</span>
      </Button>
      <AnnouncementModal
        isOpen={isAnnouncementModalOpen}
        onClose={() => setIsAnnouncementModalOpen(false)}
        onSubmit={(contentHtml) =>
          createAnnouncement({ contentHtml, narrativeId: id })
        }
      />
    </>
  );
};
